import React from "react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Card, CardContent } from "../ui/card";
import { MapPin, Phone, Truck, CheckCircle2, MessageCircle, Edit, XCircle, RotateCcw, User } from "lucide-react";
import { DELIVERY_STATUS, deliveryWhatsAppUrl, fmtDateTimeBR } from "./deliveryUtils";

const fmt = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const Actions = ({ d, isManager, companyName, on }) => {
  const wa = (kind) => window.open(deliveryWhatsAppUrl(d, companyName, kind), "_blank");
  const open = d.status === "agendada" || d.status === "em_rota";
  return (
    <div className="flex flex-wrap gap-1 pt-2 border-t">
      {d.status === "agendada" && <Button size="sm" variant="outline" onClick={() => on.start(d)} data-testid={`delivery-start-${d.id}`}><Truck className="h-3 w-3 mr-1" />Saiu para entrega</Button>}
      {open && <Button size="sm" onClick={() => on.confirm(d)} data-testid={`delivery-confirm-${d.id}`}><CheckCircle2 className="h-3 w-3 mr-1" />Entregue</Button>}
      {d.status !== "cancelada" && (
        <Button size="sm" variant="outline" onClick={() => wa(d.status)} data-testid={`delivery-whatsapp-${d.id}`}>
          <MessageCircle className="h-3 w-3 mr-1" />{d.status === "entregue" ? "Avisar entrega" : d.status === "em_rota" ? "Avisar saída" : "Avisar agendamento"}
        </Button>
      )}
      {isManager && open && <Button size="sm" variant="outline" onClick={() => on.edit(d)} data-testid={`delivery-edit-${d.id}`}><Edit className="h-3 w-3 mr-1" />Reagendar</Button>}
      {isManager && open && <Button size="sm" variant="outline" className="text-red-600" onClick={() => on.cancel(d)} data-testid={`delivery-cancel-${d.id}`}><XCircle className="h-3 w-3 mr-1" />Cancelar</Button>}
      {isManager && !open && <Button size="sm" variant="outline" onClick={() => on.reopen(d)} data-testid={`delivery-reopen-${d.id}`}><RotateCcw className="h-3 w-3 mr-1" />Reabrir</Button>}
    </div>
  );
};

export default function DeliveryCard({ d, isManager, companyName, on, late }) {
  const st = DELIVERY_STATUS[d.status] || DELIVERY_STATUS.agendada;
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(d.address || "")}`;
  return (
    <Card data-testid={`delivery-card-${d.id}`} className={late ? "border-red-500 border-2" : ""}>
      <CardContent className="p-3 space-y-1">
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="font-bold">#{String(d.sale_number || "").padStart(4, "0")} · {d.client_name}</p>
            <p className="text-xs">{fmt(d.total)}{d.freight > 0 ? ` (frete ${fmt(d.freight)})` : ""}</p>
          </div>
          <div className="flex flex-col items-end gap-1">
            <Badge className={st.cls} data-testid={`delivery-status-${d.id}`}>{st.label}</Badge>
            {late && <Badge variant="destructive">Atrasada</Badge>}
          </div>
        </div>
        <a href={mapUrl} target="_blank" rel="noreferrer" className="text-xs flex items-start gap-1 underline"><MapPin className="h-3 w-3 mt-0.5 shrink-0" />{d.address}</a>
        {d.contact_phone && <p className="text-xs flex items-center gap-1"><Phone className="h-3 w-3" />{d.contact_phone}</p>}
        <p className="text-xs flex items-center gap-1"><User className="h-3 w-3" />Transportador: <b>{d.driver_name || "não definido"}</b></p>
        <ul className="text-xs pl-1">{(d.items || []).map((i, k) => <li key={k}>• {i.quantity} {i.unit} {i.product_name}</li>)}</ul>
        {d.notes && <p className="text-xs italic">Obs.: {d.notes}</p>}
        {d.status === "entregue" && (
          <p className="text-xs bg-green-50 border border-green-300 rounded p-1" data-testid={`delivery-received-${d.id}`}>
            Entregue em {fmtDateTimeBR(d.delivered_at)} · recebido por <b>{d.received_by}</b>{d.delivered_by_name ? ` · confirmado por ${d.delivered_by_name}` : ""}
          </p>
        )}
        <Actions d={d} isManager={isManager} companyName={companyName} on={on} />
      </CardContent>
    </Card>
  );
}
